// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "client-editor/" + ({"2045":"TabsFilter","4662":"TagsFilter","5090":"wix-bookings-services-preferences-modal","7342":"DropdownFilter"}[chunkId] || chunkId) + ".chunk.min.css";
};